'use client'

import React, { HTMLAttributes } from 'react';

import styles from './styles.module.css'
import { usePathname } from 'next/navigation';

interface IUnderlinedButtonProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  isUnerlined: boolean;
  handleClick: () => void;
}

export const UnderlinedButton: React.FC<IUnderlinedButtonProps> = ({
  title,
  handleClick,
  isUnerlined,
  className,
}) => {
  const pathname = usePathname();
  return (
    <button
      className={`
        ${styles['link']} transition delay-200 flex flex-col w-fit text-gray-500 space-y-4 h-fit text-base
        hover:text-gray-900 ${isUnerlined && '!text-gray-900 ' + styles['selected-link']}
        ${className}
      `}
      onClick={() => handleClick()}
    >
      <span>{title}</span>
    </button>
  );
};
